import { usePage } from '@inertiajs/vue3'

export const usePermission = (permission) =>
  usePage().props._user.permissions.findIndex(
    ({ name }) => name === permission,
  ) > -1
